import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

/** ![searchXIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+PHJlY3QgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz48cGF0aCBkPSJtMTMuNSA4LjUtNSA1TTguNSA4LjVsNSA1Ii8+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Im0yMSAyMS00LjMtNC4zIi8+PC9zdmc+) */
const searchXIcon = /*#__PURE__*/jsxs(Fragment, {
  children: [/*#__PURE__*/jsx("path", {
    d: "m13.5 8.5-5 5M8.5 8.5l5 5"
  }), /*#__PURE__*/jsx("circle", {
    cx: 11,
    cy: 11,
    r: 8
  }), /*#__PURE__*/jsx("path", {
    d: "m21 21-4.3-4.3"
  })]
});

export { searchXIcon };
